
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe04 as ObiHydraulicPipe04Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-04.js';
 
 
 

 
 export const ObiHydraulicPipe04 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-04',
   elementClass: ObiHydraulicPipe04Element,
   events: {
     
   }
  });
 
 